import React from 'react';

export default ({icon}) => {
    return (
        <img src={`/img/icons/${icon}.svg`} />
    )
}